import { render, staticRenderFns } from "./aboutCourse.vue?vue&type=template&id=07f83ae1&"
import script from "./aboutCourse.vue?vue&type=script&lang=js&"
export * from "./aboutCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports